import React, { useState, useRef, useEffect } from "react";
import { makeStyles, Avatar } from '@material-ui/core';
import { CurriculumMasterData } from '../../../services';
import loadImage from '../../../images/image.svg';
import pdfIcon from '../../../images/pdf-icon.svg';
import wordIcon from '../../../images/word-icon.svg';
import excelIcon from '../../../images/excel-icon.svg';
import txtIcon from '../../../images/notepad-icon.svg';
import videoImage from '../../../images/video-icon.svg';
import { cacheStorage } from "./cacheStorage";

const useStyles = makeStyles(theme => ({
    avatarSize: {
        display: 'inline-flex'
    },
    imgSize: {
        width: '60px',
        height: '60px',
        cursor: "pointer"
    }
}))

const LazyImageLoader = (props) => {
    const classes = useStyles()
    const [imageUrl, setImageUrl] = useState();
    const [isLoading, setIsLoading] = useState(true);
    const documentType = props.documentType;

    useEffect(() => {
        setImageUrl('');
    }, [])

    useEffect(() => {
        if (props.documentName && props.documentType) {
            let imageUrl = cacheStorage.getPhotoFromLocalStorage(props.documentName);
            if (imageUrl) {
                setIsLoading(false);
                setImageUrl(imageUrl);
            }
            else
                getImageURL(props.documentName, props.documentType);
        }
    }, [props.documentName, props.documentType])

    const getImageURL = (documentName, documentType) => {
        if (documentType && documentType.includes("image")) {
            setIsLoading(true);
            CurriculumMasterData.getMediaURL(documentName).then((result) => {
                if (result) {
                    setImageUrl(result);
                    cacheStorage.savePhotoToLocalStorage(documentName, result);
                }
                setIsLoading(false);
            })
                .catch(err => {
                    console.log(err)
                    setIsLoading(false);
                });
        }
    }

    const getThumbnailImage = () => {
        if (documentType.includes("image")) {
            return loadImage;
        }
        else if (documentType.includes("pdf")) {
            return pdfIcon;
        }
        else if (documentType.includes("video")) {
            return videoImage;
        }
        else if (documentType.includes("word")) {
            return wordIcon;
        }
        else if (documentType.includes("xlx") || documentType.includes("excel") || documentType.includes("spreadsheet")) {
            return excelIcon;
        }
        else if (documentType.includes("txt") || documentType.includes("text")) {
            return txtIcon;
        }
        else {
            return loadImage;
        }
    }

    return (
        <>
            {props.showAvatar &&
                (isLoading ?
                    <Avatar className={props.className ?? classes.avatarSize} variant="circular" sizes="small"
                        id={"av" + props.documentName}
                        src={getThumbnailImage()}></Avatar>
                    :
                    <Avatar className={props.className ?? classes.avatarSize} variant="circular" sizes="small"
                        id={"av" + props.documentName}
                        src={imageUrl}></Avatar>
                )
            }
            {props.showImage &&
                (isLoading ?
                    <img
                        id={"img" + props.documentName}
                        src={getThumbnailImage()}
                        className={props.className ?? classes.imgSize}
                        onClick={(e) => { props.onClick(props.documentName) }}
                        style={props.mediaStyle ?? null}
                    />
                    :
                    <img
                        src={documentType && documentType.includes("image") ? imageUrl : getThumbnailImage()}
                        className={props.className ?? classes.imgSize}
                        onClick={(e) => { props.onClick(props.documentName) }}
                        style={props.mediaStyle ?? null}
                    />
                )
            }
        </>
    )
}

export default LazyImageLoader;